import React from 'react';
import { Link } from '@chakra-ui/react';
export function SkipLink() {
  return <Link href="#main-content" position="absolute" left="-999px" width="1px" height="1px" top="auto" overflow="hidden" zIndex={9999} _focus={{
    position: 'fixed',
    top: 4,
    left: 4,
    width: 'auto',
    height: 'auto',
    padding: 4,
    bgGradient: 'linear(to-r, #2c0842, #1E73BE)',
    color: 'white',
    textDecoration: 'none',
    borderRadius: 'md',
    boxShadow: 'lg'
  }} data-id="element-127">
      Skip to main content
    </Link>;
}